import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import { CONTACT } from './Constants';
export function FinalCTA() {
  return <section className="py-20 bg-celeste text-center" data-id="element-81">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <h2 className="text-3xl md:text-4xl font-bold text-azul mb-6" data-id="element-83">
          Dar el primer paso puede cambiar el camino
        </h2>
        <p className="text-xl text-azul/80 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-84">
          Si tú o alguien cercano necesita apoyo frente a una situación de
          dependencia a drogas o alcohol, puedes escribirnos o llamarnos. En
          Evolución Chile te orientaremos con respeto, confidencialidad y
          humanidad.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-85">
          <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 border border-transparent rounded-full shadow-lg text-lg font-semibold text-white bg-whatsapp hover:bg-whatsapp-hover transition-colors" data-id="element-86">
            <MessageCircle className="w-6 h-6 mr-2" data-id="element-87" />
            Hablar por WhatsApp
          </a>
          <a href={CONTACT.phoneUrl} className="inline-flex items-center justify-center px-8 py-4 border-2 border-azul rounded-full text-lg font-semibold text-azul hover:bg-azul hover:text-white transition-colors" data-id="element-88">
            <Phone className="w-6 h-6 mr-2" data-id="element-89" />
            Llamar ahora
          </a>
        </div>
      </div>
    </section>;
}